import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { push } from 'connected-react-router'
import isMobile from 'ismobilejs'
import cx from 'classnames'
import { Div, H1, P, Input, Button, Span } from '@driftt/tide-core'

import { updateUserProperties } from 'modules/user/actions'

import { shuffle } from 'utils'
import { isExtensionInstalled } from 'utils/extension'
import { track, page, getVideoSignupReferrer } from 'utils/trackingUtils'

import './style.css'

const surveyOptions = [
  {
    isSelected: false,
    label: `💰 Sales`
  },
  {
    isSelected: false,
    label: `🤝 Customer Success`
  },
  {
    isSelected: false,
    label: `💼 Client Service`
  },
  {
    isSelected: false,
    label: `📣 Marketing`
  },
  {
    isSelected: false,
    label: `👩‍💼 Management`
  }
]

const otherOption = {
  isSelected: false,
  label: `📹 Other:`,
  textInput: ''
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    push,
    updateUserProperties,
  }, dispatch),
})
class VideoSurveyStep extends React.Component {
  constructor(props) {
    super(props)
    
    let shuffledSurveyOptions = surveyOptions

    // avoid adding duplicate "other" options & overeager shuffling
    if (!surveyOptions.some(({ label }) => label.includes('Other'))) {
      shuffledSurveyOptions = shuffle(surveyOptions)
      shuffledSurveyOptions.push(otherOption)
    }
    
    this.state = {
      surveyOptions: shuffledSurveyOptions,
      selectedOption: null,
      freeTextInput: '',
      hasExtension: false,
      isLoading: false,
    }
  }

  componentDidMount = () => {
    page('Video Onboarding Survey', {
      source: getVideoSignupReferrer()
    })
  }

  async componentWillMount() {
    const hasExtension = await isExtensionInstalled()
    this.setState({ hasExtension: hasExtension })
  }

  toggleLoading = () => this.setState({ isLoading: !this.state.isLoading })

  setSelectedOption = (selectedOption) => {
    this.setState({ selectedOption: selectedOption })
  }

  onTextInputChange = (event) => {
    const value = event.target ? event.target.value : ''

    this.setState({ freeTextInput: value })
  }

  advanceToNextStep = () => {
    if (isMobile.any) {
      this.props.actions.push('/video/success')
    } else if (this.state.hasExtension) {
      this.props.actions.push('/video/landing')
    } else {
      this.props.actions.push('/video/extension')
    }
  }

  handleSkipSurvey = () => {
    track('Video Onboarding Survey Skipped')
    window.localStorage.setItem('video_survey_completed', 'skipped')
    this.advanceToNextStep()
  }

  submitSurvey = (selectedOption) => {
    this.toggleLoading()
    // remove emoji appended to the front of the response
    const surveyResponse = selectedOption.slice(3)
    track('Video Onboarding Survey Submitted', { selectedOption: surveyResponse, freeResponse: this.state.freeTextInput })
    this.props.actions.updateUserProperties({
      properties: {
        videoOnboardingSurveyResults: surveyResponse
      }
    })
    window.localStorage.setItem('video_survey_completed', surveyResponse)

    setTimeout(() => {
      this.advanceToNextStep()
    }, 1000)
  }

  render() {
    const { surveyOptions, selectedOption, freeTextInput, hasExtension, isLoading } = this.state

    return (
      <Div className="video-card-container">
        <H1>
          <span role="img" aria-label="confetti">&#127882;</span>
          Welcome to Drift Video!
          <span role="img" aria-label="confetti">&#127881;</span>
        </H1>
        <P>Let us know what you want to use Drift Video for and we&rsquo;ll get you set up for success.</P>
        <Div className="video-survey-options-container">
          {surveyOptions.map((option, i) => {
            const optionLabel = option.label
            let optionDisplayValue = option.label
            if (option.hasOwnProperty('textInput')) {
              optionDisplayValue = (
                <span className="video-survey-free-text-input" key={`video-survey-option-${i}`}>
                  {option.label}&nbsp;
                  <Input
                    placeholder="None of the above" 
                    onChange={this.onTextInputChange}
                    value={freeTextInput} />
                </span>
              )
            }
            return (
              <Div onClick={() => this.setSelectedOption(optionLabel)} key={`video-survey-option-${i}`}>
                <Input 
                  className={cx('video-survey-option', { 'selected' : selectedOption === optionLabel })} 
                  type="checkbox" 
                  label={optionDisplayValue}
                  checked={selectedOption === optionLabel}
                  key={`video-survey-option-${i}`}
                  />
              </Div>
            )
          })}
        </Div>
        <Button 
          className="video-survey-button" 
          type="primary"
          size="large"
          loading={isLoading}
          disabled={!selectedOption}
          onClick={() => this.submitSurvey(selectedOption)}>
          {hasExtension ? 'Take me to my account!' : 'Get the extension'}
        </Button>
        <Span className="skip-survey-subcopy" onClick={this.handleSkipSurvey} >Skip this step for now</Span>
      </Div>
    )
  }
}

export default connect(null, mapDispatchToProps)(VideoSurveyStep)
